import React from 'react';
import PropTypes from 'prop-types';

const IconClock = props => {
    const { className, rootClassName } = props;
    const classes = rootClassName || className;
    return (
        <svg
            className={classes}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                stroke="currentColor"
            >
                <circle cx="8" cy="8" r="6.25" />
                <path d="M8 4.5V8l2.5 2.5" />
            </g>
        </svg>
    );
};

IconClock.defaultProps = {
    className: null,
    rootClassName: null,
};

IconClock.propTypes = {
    className: PropTypes.string,
    rootClassName: PropTypes.string,
};

export default IconClock;
